import React, { createContext, useState, useEffect, act } from "react";
import { useNavigate } from "react-router-dom";

import {
  propertyTypeData,
  deviceListApi,
  recommendedProductApi,
} from "../../api/Api";
import { useParams, useLocation } from "react-router-dom";
import RouteConstants from "../../constants/RouteConstants.json";
import DomainConfig from "../../constants/DomainConfig.json";
import { cache } from "react";

export const HomePageContext = createContext({});
export const HomePageContextProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState("1bhk");
  const [devices, setDevices] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [consumptionValue, setConsumptionValue] = useState(30);
  const [hours, setHours] = useState(1);
  const [isDeviceSelected, setIsDeviceSelected] = useState(true);
  const [showAddDevice, setShowAddDevice] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalWatt, setTotalWatt] = useState("");
  const [deviceList, setDeviceList] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [resetPopup, setResetPopup] = useState(false);
  const [initialDevices, setInitialDevices] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [pendingTab, setPendingTab] = useState(null);
  const [initialConsumptionValue, setInitialConsumptionValue] = useState(30);
  const [initialHours, setInitialHours] = useState(1);
  const [urlStore, setUrlStore] = useState("");
  const [deviceLimits, setDeviceLimits] = useState(null);
  const [domainID, setDomainID] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = () => {
    setIsDeviceSelected(true);
    // setIsDeviceSelected(!isDeviceSelected);
  };

  const handlePowerDecrement = () => {
    if (hours > 1) {
      setHours(hours - 1);
    }
  };

  const handlePowerIncrement = () => {
    if (hours < 10) {
      setHours(hours + 1);
    }
  };

  const restrictPowerData = (e) => {
    const value = Math.max(1, Math.min(10, Number(e.target.value)));
    setHours(value);
  };

  const handleSideBarChange = (e) => {
    const newValue = Number(e.target.value);
    setConsumptionValue(newValue);
  };

  const handleAddDeviceSubmit = () => {
    const newDevices = [...devices];

    selectedIds.forEach((id) => {
      const existingDeviceIndex = newDevices.findIndex(
        (device) => device.deviceId === id
      );

      const deviceData = deviceList.find((device) => device._id === id);
      const deviceLimit = deviceData?.allowedQuantity ?? null;

      if (existingDeviceIndex !== -1) {
        if (
          deviceLimit === null ||
          newDevices[existingDeviceIndex].quantity < deviceLimit
        ) {
          newDevices[existingDeviceIndex].quantity = Math.min(
            newDevices[existingDeviceIndex].quantity + 1,
            deviceLimit ?? Infinity
          );
        }
      } else {
        if (deviceLimit === null || deviceLimit > 0) {
          newDevices.push({
            ...deviceData,
            deviceId: deviceData._id,
            deviceName: deviceData.name,
            deviceUsage: deviceData.usage,
            quantity: Math.min(1, deviceLimit ?? 1),
          });
        }
      }
    });

    setDevices(newDevices);
    setShowAddDevice(false);
    setSelectedIds([]);
  };

  const showPropertyTypeData = async () => {
    const propertyData = {
      propertyType: activeTab, //1bhk,2bhk,3bhk,4bhk,villa
      type: "device", //device or room
    };
    if (hasChanges === false) {
      try {
        // setLoaderStatus(true);
        const getData = await propertyTypeData(propertyData);
        if (getData?.status === 200) {
          setLoaderStatus(false);
          setDevices(getData?.data?.data || []);
          setInitialDevices(
            JSON.parse(JSON.stringify(getData?.data?.data || []))
          );
        }
      } catch (error) {
        const responseStatus = error?.response?.status;
        setLoaderStatus(false);
        setErrorPopup(true);
        setErrorMessage(error?.response?.data?.message);
      }
    }
  };

  const handleTabsSwitch = (newTab) => {
    if (hasChanges) {
      setPendingTab(newTab);
      setResetPopup(true);
    } else {
      setActiveTab(newTab);
    }
  };

  const showDeviceData = async () => {
    try {
      const getData = await deviceListApi();
      if (getData?.status === 200) {
        setDeviceList(getData?.data?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const newLimits = {};
    devices.forEach((device) => {
      const product = deviceList.find((item) => item._id === device.deviceId);
      newLimits[device.deviceId] = product?.allowedQuantity ?? null;
    });
    setDeviceLimits(newLimits);
  }, [devices, deviceList]);

  useEffect(() => {
    showDeviceData();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const isDevicesChanged =
      JSON.stringify(devices) !== JSON.stringify(initialDevices);
    const isConsumptionChanged = consumptionValue !== initialConsumptionValue;
    const isHoursChanged = hours !== initialHours;

    if (isDevicesChanged || isConsumptionChanged || isHoursChanged) {
      setHasChanges(true);
    } else {
      setHasChanges(false);
    }
  }, [devices, consumptionValue, hours]);

  const addDevicePopupShow = () => {
    setShowAddDevice(true);
    showDeviceData();
  };

  useEffect(() => {
    showPropertyTypeData();
  }, [activeTab]);

  useEffect(() => {
    const totalAmountWatt = Array.isArray(devices)
      ? devices.reduce(
          (total, device) => total + device.deviceUsage * device.quantity,
          0
        )
      : 0;
    setTotalWatt(totalAmountWatt);
  }, [devices, setTotalWatt]);

  useEffect(() => {
    const host = window.location.hostname;
    const hostname = host.split(".").pop();
    setUrlStore(hostname);
  }, [location.hostname]);

  const handleSubmitProduct = async () => {
    const productDetails = {
      siteOrigin: urlStore, // com, in
      propertyType: activeTab, //1bhk,2bhk,3bhk,4bhk,villa
      totalWatts: totalWatt,
      powerBackup: hours,
      utilization: consumptionValue,
      devices: devices,
    };

    try {
      setLoaderStatus(true);
      const getData = await recommendedProductApi(productDetails);
      console.log("getData", getData);
      if (getData?.status === 200) {
        navigate(`/products`, {
          state: {
            productData: getData?.data?.data,
            domain: urlStore,
            warningData: getData?.data?.data?.defaultSKUMessage,
          },
        });
        setLoaderStatus(false);
      }
    } catch (error) {
      setLoaderStatus(false);
      setErrorPopup(true);
      setErrorMessage(error?.response?.data?.message);
    }
  };

  const conformationData = () => {
    setResetPopup(false);
    setHasChanges(false);
    setActiveTab(pendingTab);
    showPropertyTypeData();
  };

  const handleContactClickWhenIn = () => {
    window.open(
      "https://www.vguard.in/home/contact-us",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleContactClickWhenCom = () => {
    window.open("https://vguard.com/", "_blank", "noopener,noreferrer");
  };

  const handleContactClick = () => {
    if (urlStore == "in") {
      handleContactClickWhenIn();
    }
  };

  const providerValue = {
    activeTab,
    setActiveTab,
    devices,
    setDevices,
    quantity,
    setQuantity,
    consumptionValue,
    setConsumptionValue,
    hours,
    setHours,
    isDeviceSelected,
    setIsDeviceSelected,
    handleToggle,
    handlePowerDecrement,
    handlePowerIncrement,
    handleSideBarChange,
    restrictPowerData,
    showAddDevice,
    handleAddDeviceSubmit,
    selectedIds,
    setSelectedIds,
    addDevicePopupShow,
    deviceList,
    setShowAddDevice,
    setTotalWatt,
    totalWatt,
    handleSubmitProduct,
    resetPopup,
    conformationData,
    setResetPopup,
    setHasChanges,
    loaderStatus,
    errorPopup,
    setErrorPopup,
    handleTabsSwitch,
    errorMessage,
    handleContactClick,
    deviceLimits,
    urlStore,
  };
  return (
    <HomePageContext.Provider value={providerValue}>
      {children}
    </HomePageContext.Provider>
  );
};
